import { render } from "./Member_comment.vue?vue&type=template&id=737936b2&scoped=true"
import script from "./Member_comment.vue?vue&type=script&lang=js"
export * from "./Member_comment.vue?vue&type=script&lang=js"

import "./Member_comment.vue?vue&type=style&index=0&id=737936b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737936b2"]])

export default __exports__